import { ServiceBase, Result } from "./ServiceBase";

export default class SolrService extends ServiceBase {

    public static async rebuild(): Promise<Result<boolean>> {

        var result = await this.requestJson<boolean>({
            url: `/api/solr/triggerrebuild`,
            method: "POST"            
        });

        return result;
    }
}
